var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "va-row" },
    [
      _c(
        "div",
        { staticClass: "flex md12 xs12" },
        [
          _c("vuestic-widget", [
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.app"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "" },
                      model: {
                        value: _vm.value_app,
                        callback: function ($$v) {
                          _vm.value_app = $$v
                        },
                        expression: "value_app",
                      },
                    },
                    _vm._l(_vm.appList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.orderCurrency"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_order_currency,
                        callback: function ($$v) {
                          _vm.value_order_currency = $$v
                        },
                        expression: "value_order_currency",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.currencyList, function (val, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: val, value: val },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.region"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_region,
                        callback: function ($$v) {
                          _vm.value_region = $$v
                        },
                        expression: "value_region",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.regionList, function (val, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: val.label, value: val.value },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.method"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_method,
                        callback: function ($$v) {
                          _vm.value_method = $$v
                        },
                        expression: "value_method",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.methodList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item, value: item },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.status"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_status,
                        callback: function ($$v) {
                          _vm.value_status = $$v
                        },
                        expression: "value_status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.statusList, function (item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { label: item.desc, value: item.code },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.dateMode"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_time,
                        callback: function ($$v) {
                          _vm.value_time = $$v
                        },
                        expression: "value_time",
                      },
                    },
                    _vm._l(_vm.timeModeList, function (tvalue, name, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: name, value: tvalue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.timeZone"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.currTimeZone,
                        callback: function ($$v) {
                          _vm.currTimeZone = $$v
                        },
                        expression: "currTimeZone",
                      },
                    },
                    _vm._l(_vm.timeZoneList, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { value: item, label: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.dateRange"))),
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "100% !important" },
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions,
                      "unlink-panels": "",
                      "range-separator": "-",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      "start-placeholder": "start",
                      "end-placeholder": "end",
                    },
                    on: { focus: _vm.limitNextDay },
                    model: {
                      value: _vm.dateVals,
                      callback: function ($$v) {
                        _vm.dateVals = $$v
                      },
                      expression: "dateVals",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.fileType"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.file_type,
                        callback: function ($$v) {
                          _vm.file_type = $$v
                        },
                        expression: "file_type",
                      },
                    },
                    _vm._l(_vm.fileTypeOptions, function (mvalue, name, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: name, value: mvalue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.searchMode"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.value_mode,
                        callback: function ($$v) {
                          _vm.value_mode = $$v
                        },
                        expression: "value_mode",
                      },
                    },
                    _vm._l(_vm.modeList, function (mvalue, name, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: name, value: mvalue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex md4" },
                [
                  _c("div", { staticClass: "select-title" }, [
                    _vm._v(_vm._s(_vm.$t("t.searchKey"))),
                  ]),
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.searchVal,
                      callback: function ($$v) {
                        _vm.searchVal = $$v
                      },
                      expression: "searchVal",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "va-row",
                staticStyle: { "justify-content": "center" },
              },
              [
                _c("div", { staticClass: "flex mobile-btn mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-micro",
                      on: { click: _vm.searchOrder },
                    },
                    [
                      _c("div", { staticClass: "btn-with-icon-content" }, [
                        _c("i", { staticClass: "ion-md-search ion" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("translate")("basic.button.search")) +
                            "\n            "
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm.permissions["Download"]
                  ? _c("div", { staticClass: "flex mobile-btn mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-micro",
                          on: { click: _vm.downloadOrders },
                        },
                        [
                          _c("div", { staticClass: "btn-with-icon-content" }, [
                            _c("i", { staticClass: "ion-md-download ion" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("translate")("basic.button.download")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "flex mobile-btn mt-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-micro",
                      on: { click: _vm.popCreateOrderWin },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-with-icon-content",
                          staticStyle: { "max-width": "fit-content" },
                        },
                        [
                          _c("i", {
                            staticClass: "vuestic-icon vuestic-icon-files ion",
                          }),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")("basic.button.createOrder")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c("br"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex xs12 md12 w-table" },
        [
          _c("vuestic-widget", { attrs: { id: "dategridPayOrder" } }, [
            _c("div", { staticClass: "table-responsive mb-0" }, [
              _c(
                "table",
                { staticClass: "table table-striped first-td-padding" },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      _vm._l(_vm.tableHeaderList, function (item, index) {
                        return _c("th", { key: index }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("translate")(item.label)) +
                              "\n              "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm.list && _vm.list.length > 0
                    ? _c(
                        "tbody",
                        _vm._l(_vm.list, function (item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.transactionId,
                                    expression: "showColumnsList.transactionId",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.fetchDetails(item.trade_no)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "alink",
                                        attrs: { href: "javascript:void(0);" },
                                      },
                                      [_vm._v(_vm._s(item.trade_no))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showColumnsList.merchantReference,
                                    expression:
                                      "showColumnsList.merchantReference",
                                  },
                                ],
                              },
                              [
                                _c("span", { staticClass: "action-color-1" }, [
                                  _vm._v(_vm._s(item.out_trade_no)),
                                ]),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.appName,
                                    expression: "showColumnsList.appName",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(item.app_name))]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showColumnsList.referenceDateTime,
                                    expression:
                                      "showColumnsList.referenceDateTime",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.dateFormat(item.create_time)) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.method,
                                    expression: "showColumnsList.method",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.method == undefined ||
                                        item.method == ""
                                        ? "N/A"
                                        : item.method
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.channel,
                                    expression: "showColumnsList.channel",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.channel_name == undefined ||
                                        item.channel_name == ""
                                        ? "N/A"
                                        : item.channel_name
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.amount,
                                    expression: "showColumnsList.amount",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.order_currency) +
                                    " " +
                                    _vm._s(item.order_amount) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.status,
                                    expression: "showColumnsList.status",
                                  },
                                ],
                                attrs: { align: "right" },
                              },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      "disable-transitions": "",
                                      type: _vm.getStatusColor(
                                        item.trade_status
                                      ),
                                    },
                                  },
                                  [_vm._v(_vm._s(item.trade_status))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.muid,
                                    expression: "showColumnsList.muid",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.out_uid == undefined ||
                                        item.out_uid == ""
                                        ? "N/A"
                                        : item.out_uid
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.email,
                                    expression: "showColumnsList.email",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.email == undefined ||
                                        item.email == ""
                                        ? "N/A"
                                        : item.email
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.subject,
                                    expression: "showColumnsList.subject",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.subject == undefined ||
                                        item.subject == ""
                                        ? "N/A"
                                        : item.subject
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showColumnsList.updateTime,
                                    expression: "showColumnsList.updateTime",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.update_time
                                        ? _vm.dateFormat(item.update_time)
                                        : ""
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        }),
                        0
                      )
                    : _c("tbody", [
                        _c("tr", [
                          _c("td", {
                            attrs: { colspan: "11" },
                            domProps: {
                              textContent: _vm._s(_vm.$t("t.noDataNoOrder")),
                            },
                          }),
                        ]),
                      ]),
                ]
              ),
              _vm.tableOrderHeader.length > 0
                ? _c("div", { staticClass: "table-responsive mb-0 mt-3" }, [
                    _c(
                      "table",
                      { staticClass: "table table-striped first-td-padding" },
                      [
                        _c("thead", [
                          _c(
                            "tr",
                            _vm._l(
                              _vm.tableOrderHeader,
                              function (item, index) {
                                return _c("th", { key: index }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm._f("translate")(item)) +
                                      "\n                "
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.tableOrderList, function (item, i) {
                            return _c(
                              "tr",
                              { key: i },
                              _vm._l(_vm.tableOrderHeader, function (key, j) {
                                return _c("td", { key: j }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item[key]) +
                                      "\n                "
                                  ),
                                ])
                              }),
                              0
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm.isMobile === "pc"
              ? _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.total > 0,
                          expression: "total > 0",
                        },
                      ],
                      attrs: {
                        total: _vm.total,
                        "page-size": _vm.limit,
                        layout: "total, sizes, prev, pager, next, jumper",
                        background: "",
                        page: _vm.page,
                        limit: _vm.limit,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "update:limit": function ($event) {
                          _vm.limit = $event
                        },
                        pagination: _vm.orderData,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("pagination", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.total > 0,
                          expression: "total > 0",
                        },
                      ],
                      attrs: {
                        total: _vm.total,
                        layout: "total, prev, pager, next",
                        background: "",
                        page: _vm.page,
                        limit: _vm.limit,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "update:limit": function ($event) {
                          _vm.limit = $event
                        },
                        pagination: _vm.orderData,
                      },
                    }),
                  ],
                  1
                ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "padding-top": "3vh" },
          attrs: {
            title: _vm.$t("menu.paymentOrderDetails2"),
            id: "paymentDetails",
            visible: _vm.dialogTableVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            close: _vm.initRefund,
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex xs12 md12 w-table" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.details") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-responsive",
                          attrs: { id: "details" },
                        },
                        [
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm._f("translate")(
                                          "tables.detailsInfo.transactionID"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.amount"
                                      )
                                    )
                                  ),
                                ]),
                                _vm.isPartialPay
                                  ? _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.detailsInfo.receivedAmount"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.prodDesc"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.method"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.Status"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.createDate"
                                      )
                                    )
                                  ),
                                ]),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "tables.detailsInfo.partnerID"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.detailInfo, function (val, index) {
                                return _c(
                                  "tr",
                                  { key: index },
                                  _vm._l(val, function (item, i) {
                                    return _c(
                                      "td",
                                      { key: i, style: _vm.centerText },
                                      [
                                        _vm.canRefundMethod && item === "Refund"
                                          ? _c("span", [
                                              !!_vm.paymentOrderData
                                                .support_refund
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger btn-micro",
                                                      class: {
                                                        disable:
                                                          !_vm.refundCanDo,
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          !_vm.refundCanDo,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.showMediumModal,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(item) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : item === "Callback"
                                          ? _c("span", [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-info btn-micro",
                                                  attrs: {
                                                    disabled: _vm.isLoading,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.callbackOrderStatus,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.isLoading
                                                          ? ""
                                                          : "callback"
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _vm.isLoading
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("loading")
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          : item === "Match Status"
                                          ? _c("span", [
                                              _vm.locationHost ===
                                                `dashboard-test.${_vm.envName}.com` ||
                                              _vm.locationHost ===
                                                "localhost:8001"
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-info btn-micro",
                                                      on: {
                                                        click:
                                                          _vm.showModalFillOrder,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(item) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item) +
                                                  "\n                      "
                                              ),
                                            ]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "block" }),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm.paymentOrderData.detail
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md12" },
                    [
                      _c(
                        "vuestic-widget",
                        { attrs: { headerText: _vm.$t("tables.statusHis") } },
                        [
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-striped first-td-padding",
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.statusHisInfo.status"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.statusHisInfo.date"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.statusHisInfo.amount"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.detailsInfo.cbStatus"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "tables.usering.actions"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.paymentOrderData.detail.trans_logs,
                                    function (item, idx) {
                                      return _c("tr", { key: idx }, [
                                        _c("td", [
                                          _vm._v(_vm._s(item.newLogStatus)),
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(item.newCreateTime)),
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(item.refundMoney)),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(item.logCallbackStatus)
                                          ),
                                        ]),
                                        _vm.isProviderDelbank
                                          ? _c("td", [
                                              item.newLogStatus === "Success" &&
                                              !!_vm.paymentOrderData
                                                .channel_info
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-micro",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadDelbankPdfSuccess(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-with-icon-content",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "ion-md-download",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.isShowRefundDownload &&
                                              item.type === "Refund" &&
                                              item.log_status === "Refunded"
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-micro",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadDelbankPdfRefund(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-with-icon-content",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "ion-md-download",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : !_vm.isProviderDelbank &&
                                            item.type === "Refund" &&
                                            item.log_status === "Refunded"
                                          ? _c("td", [
                                              _vm.paymentOrderData.detail.trans_base.method.toLowerCase() ===
                                              "pix"
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-micro",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDownloadPdf(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-with-icon-content",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "ion-md-download",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex xs12 md6" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.buyer") } },
                    [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-striped first-td-padding",
                          },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.buyerInfo, function (bitem, bindex) {
                                return _c(
                                  "tr",
                                  {
                                    key: bindex,
                                    staticStyle: { "text-align": "left" },
                                  },
                                  _vm._l(bitem, function (bval, bid) {
                                    return _vm.hideBuyerTd(bid)
                                      ? _c(
                                          "td",
                                          { key: bid, style: _vm.sizeLeft },
                                          [
                                            _c("span", {
                                              class: _vm.spanWrapper,
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getVerticalTabTd(
                                                    bval,
                                                    bid,
                                                    "buyer",
                                                    Object.keys(bitem).indexOf(
                                                      bid
                                                    ),
                                                    bindex
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex xs12 md6" },
                [
                  _c(
                    "vuestic-widget",
                    { attrs: { headerText: _vm.$t("tables.merchant") } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-responsive",
                          attrs: { id: "merchant" },
                        },
                        [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped first-td-padding",
                            },
                            [
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.merchantInfo,
                                  function (mitem, mkey) {
                                    return _c(
                                      "tr",
                                      {
                                        key: mkey,
                                        staticStyle: { "text-align": "left" },
                                      },
                                      [
                                        _c("td", { style: _vm.sizeLeft }, [
                                          _c("span", {
                                            class: _vm.spanWrapper,
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getVerticalTabTd(
                                                  mkey,
                                                  mitem,
                                                  "merchant"
                                                )
                                              ),
                                            },
                                          }),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm.transactionInfo.length > 0
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        {
                          attrs: {
                            headerText: _vm.$t("tables.transactionCost"),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "table-responsive",
                              attrs: { id: "transCoat" },
                            },
                            [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped first-td-padding",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "tables.transactionDetails.option"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "tables.transactionDetails.setting"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("translate")(
                                              "tables.transactionDetails.fee"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.transactionInfo,
                                      function (titem, idx) {
                                        return _c(
                                          "tr",
                                          { key: idx },
                                          _vm._l(titem, function (list, t) {
                                            return _c("td", { key: t }, [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(list),
                                                },
                                              }),
                                            ])
                                          }),
                                          0
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.depositUpload.uploadUrl
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        { attrs: { headerText: _vm.$t("tables.voucher") } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "deposit-upload",
                              attrs: { id: "depositUpload" },
                            },
                            [
                              _c(
                                "ul",
                                { staticStyle: { width: "70%" } },
                                _vm._l(_vm.payVouchers, function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass: "oneline-voucher",
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "key col-md-5",
                                        domProps: {
                                          textContent: _vm._s(item.name),
                                        },
                                      }),
                                      _c("span", {
                                        staticClass: "key col-md-5",
                                        domProps: {
                                          textContent: _vm._s(item.time),
                                        },
                                      }),
                                      item.url
                                        ? _c("a", {
                                            staticClass:
                                              "iconicstroke iconicstroke-download",
                                            staticStyle: {
                                              "font-size": "24px",
                                              cursor: "pointer",
                                            },
                                            attrs: { href: item.url },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadAttachment(
                                                  item,
                                                  $event
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-primary btn-micro pull-right",
                                  attrs: {
                                    href: _vm.depositUpload.uploadUrl,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("basic.button.upload")))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.refusedFg
              ? _c("div", { staticClass: "va-row" }, [
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        { attrs: { headerText: _vm.$t("tables.antiFraud") } },
                        [
                          _c("div", { staticClass: "refused-info" }, [
                            _c("ul", { staticStyle: { width: "70%" } }, [
                              _c("li", { staticClass: "oneline-voucher" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.refusedInfo"))),
                                ]),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(_vm.refusedInfo),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex xs12 md6" },
                    [
                      _c(
                        "vuestic-widget",
                        {
                          attrs: {
                            headerText: _vm.$t("tables.paymentResponse"),
                          },
                        },
                        [
                          _c("div", { staticClass: "refused-info" }, [
                            _c("ul", { staticStyle: { width: "70%" } }, [
                              _c("li", { staticClass: "oneline-voucher" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.code"))),
                                ]),
                                _c("span", {
                                  style: _vm.sizeLeft,
                                  domProps: {
                                    textContent: _vm._s(_vm.refusalCode),
                                  },
                                }),
                              ]),
                              _c("li", { staticClass: "oneline-voucher" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.message"))),
                                ]),
                                _c("span", {
                                  style: _vm.sizeLeft,
                                  domProps: {
                                    textContent: _vm._s(_vm.refusalMsg),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "modals-page", attrs: { id: "refundReason" } },
            [
              _c(
                "vuestic-order-modal",
                {
                  ref: "mediumModal",
                  staticStyle: { height: "100%", width: "60vw" },
                  attrs: {
                    show: _vm.show,
                    okText: _vm._f("translate")("modal.confirm2"),
                    okClass: "btn btn-primary btn-micro",
                    cancelClass: "btn btn-secondary btn-micro",
                    cancelText: _vm._f("translate")("modal.cancel2"),
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.show = $event
                    },
                    cancel: _vm.handleModalClose,
                  },
                },
                [
                  _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("modal.refundReason"))),
                  ]),
                  _c("div", [
                    _c("form", [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md12" }, [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("refundAmount"),
                                    valid: _vm.isFormFieldValid("refundAmount"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.refundAmount,
                                          expression: "refundAmount",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|verifyRefundAmount",
                                          expression:
                                            "'required|verifyRefundAmount'",
                                        },
                                      ],
                                      attrs: {
                                        id: "simple-input",
                                        name: "refundAmount",
                                        "data-vv-as": "refundAmount",
                                        autocomplete: "off",
                                        required: "",
                                        oninput:
                                          "value=value.replace(/[^0-9.]+/g,'')",
                                        disabled:
                                          !_vm.paymentOrderData
                                            .support_partial_refund,
                                      },
                                      domProps: { value: _vm.refundAmount },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.refundAmount = $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        style: !_vm.paymentOrderData
                                          .support_partial_refund
                                          ? "font-size: 0.6rem; color: #4ae387; text-transform: uppercase; top: -0.6rem;"
                                          : "",
                                        attrs: { for: "simple-input" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "forms.inputs.refundAmount"
                                              )
                                            ) +
                                            "：\n                      "
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("refundAmount"),
                                            expression:
                                              "errors.has('refundAmount')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("refundAmount")
                                            ) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.isShowRefundPhoneNumber
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error":
                                          _vm.errors.has("refundTelephone"),
                                        valid:
                                          _vm.isFormFieldValid(
                                            "refundTelephone"
                                          ),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.refundTelephone,
                                                expression: "refundTelephone",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|verifyCellPhone",
                                                expression:
                                                  "'required|verifyCellPhone'",
                                              },
                                            ],
                                            attrs: {
                                              id: "refundTelephone",
                                              name: "refundTelephone",
                                              "data-vv-as": "Phone Number",
                                              maxlength: "128",
                                              autocomplete: "off",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.refundTelephone,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.refundTelephone =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "refundTelephone" },
                                            },
                                            [_vm._v("Phone Number：")]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "refundTelephone"
                                                    ),
                                                  expression:
                                                    "errors.has('refundTelephone')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "refundTelephone"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isShowRefundEmail
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error":
                                          _vm.errors.has("successfulEmail"),
                                        valid: _vm.isSuccessfulEmailValid,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _vm.isRefundMethodPix
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.successfulEmail,
                                                    expression:
                                                      "successfulEmail",
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "email",
                                                    expression: "'email'",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "successfulEmail",
                                                  name: "successfulEmail",
                                                  autocomplete: "off",
                                                },
                                                domProps: {
                                                  value: _vm.successfulEmail,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.successfulEmail =
                                                      $event.target.value
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.successfulEmail,
                                                    expression:
                                                      "successfulEmail",
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|email",
                                                    expression:
                                                      "'required|email'",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "successfulEmail",
                                                  name: "successfulEmail",
                                                  autocomplete: "off",
                                                  required: "",
                                                },
                                                domProps: {
                                                  value: _vm.successfulEmail,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.successfulEmail =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "successfulEmail" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.buyerEmail"
                                                    )
                                                  ) +
                                                  "：\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "successfulEmail"
                                                    ),
                                                  expression:
                                                    "errors.has('successfulEmail')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "successfulEmail"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error":
                                      _vm.errors.has("refundExplain"),
                                    valid:
                                      _vm.isFormFieldValid("refundExplain"),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex md12 xs12",
                                      attrs: { id: "textareawrapper" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.refundExplain,
                                                expression: "refundExplain",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'",
                                              },
                                            ],
                                            style: _vm.paddTop,
                                            attrs: {
                                              type: "text",
                                              name: "refundExplain",
                                              "data-vv-as": "Name",
                                              id: "simple-textarea",
                                              placeholder: _vm.$t(
                                                "payment.upTo100Characters"
                                              ),
                                              maxlength: "100",
                                              rows: "2",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.refundExplain,
                                            },
                                            on: {
                                              focus: _vm.resizeLabel,
                                              blur: _vm.focusLabel,
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.refundExplain =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "simple-textarea" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "forms.inputs.description"
                                                  )
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "refundExplain"
                                                    ),
                                                  expression:
                                                    "errors.has('refundExplain')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "refundExplain"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.errors.has("bank"),
                                        valid: _vm.isFormFieldValid("bank"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "bank",
                                                name: "bank",
                                                filterable: true,
                                                required: "",
                                                placeholder: _vm.$t(
                                                  "payment.pleaseSelectABank"
                                                ),
                                              },
                                              on: {
                                                change: _vm.selectBankCode,
                                              },
                                              model: {
                                                value: _vm.bankCode,
                                                callback: function ($$v) {
                                                  _vm.bankCode = $$v
                                                },
                                                expression: "bankCode",
                                              },
                                            },
                                            _vm._l(
                                              _vm.bankCodeList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has("bank"),
                                                  expression:
                                                    "errors.has('bank')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first("bank")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.errors.has("clabe"),
                                        valid: _vm.isFormFieldValid("clabe"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.clabe,
                                                expression: "clabe",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|verifyClabe",
                                                expression:
                                                  "'required|verifyClabe'",
                                              },
                                            ],
                                            attrs: {
                                              id: "clabe",
                                              name: "clabe",
                                              autocomplete: "off",
                                              required: "",
                                            },
                                            domProps: { value: _vm.clabe },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.clabe = $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "clabe" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        CLABE：\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has("clabe"),
                                                  expression:
                                                    "errors.has('clabe')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first("clabe")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error":
                                          _vm.errors.has("documentType"),
                                        valid:
                                          _vm.isFormFieldValid("documentType"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "document_type",
                                                name: "documentType",
                                                placeholder: _vm.$t(
                                                  "payment.pleaseSelectADocumentType"
                                                ),
                                                required: "",
                                              },
                                              on: {
                                                change: _vm.selectDocumentType,
                                              },
                                              model: {
                                                value: _vm.documentType,
                                                callback: function ($$v) {
                                                  _vm.documentType = $$v
                                                },
                                                expression: "documentType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.documentTypeList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "documentType"
                                                    ),
                                                  expression:
                                                    "errors.has('documentType')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "documentType"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error":
                                          _vm.errors.has("documentId"),
                                        valid:
                                          _vm.isFormFieldValid("documentId"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.documentId,
                                                expression: "documentId",
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|verifyDocumentId",
                                                expression:
                                                  "'required|verifyDocumentId'",
                                              },
                                            ],
                                            attrs: {
                                              id: "document_id",
                                              name: "documentId",
                                              autocomplete: "off",
                                              required: "",
                                            },
                                            domProps: { value: _vm.documentId },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.documentId =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "document_id" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Document id：\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.errors.has(
                                                      "documentId"
                                                    ),
                                                  expression:
                                                    "errors.has('documentId')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "documentId"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.speiFlag
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "form-group with-icon-right",
                                      class: {
                                        "has-error": _vm.errors.has("Name"),
                                        valid: _vm.isFormFieldValid("Name"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: _vm.documentName,
                                                expression: "documentName",
                                                modifiers: { trim: true },
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|verifyName",
                                                expression:
                                                  "'required|verifyName'",
                                              },
                                            ],
                                            attrs: {
                                              id: "document_name",
                                              name: "Name",
                                              autocomplete: "off",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.documentName,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.documentName =
                                                  $event.target.value.trim()
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-check valid-icon icon-right input-icon",
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "control-label",
                                              attrs: { for: "document_name" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Name：\n                      "
                                              ),
                                            ]
                                          ),
                                          _c("i", { staticClass: "bar" }),
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has("Name"),
                                                  expression:
                                                    "errors.has('Name')",
                                                },
                                              ],
                                              staticClass: "help text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first("Name")
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.checkManualRefund(_vm.detailInfo[0][3]) &&
                              !_vm.speiFlag &&
                              _vm.showCheckboxRefund(_vm.detailInfo[0][3])
                                ? _c("vuestic-checkbox", {
                                    ref: "other",
                                    attrs: {
                                      label: _vm.$t("forms.controls.options"),
                                    },
                                    model: {
                                      value: _vm.checkboxOption,
                                      callback: function ($$v) {
                                        _vm.checkboxOption = $$v
                                      },
                                      expression: "checkboxOption",
                                    },
                                  })
                                : _vm._e(),
                              _vm.dispalyOtherFg
                                ? _c("div", { attrs: { id: "user_info" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            _vm.errors.has("username"),
                                          valid:
                                            _vm.isFormFieldValid("username"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.username,
                                                  expression: "username",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "uname-input",
                                                name: "username",
                                                "data-vv-as": "Name",
                                                required: "",
                                              },
                                              domProps: { value: _vm.username },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.username =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "uname-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.username"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has(
                                                        "username"
                                                      ),
                                                    expression:
                                                      "errors.has('username')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "username"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("cpfNO"),
                                          valid: _vm.isFormFieldValid("cpfNO"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.cpfNO,
                                                  expression: "cpfNO",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "cpfNO-input",
                                                name: "cpfNO",
                                                "data-vv-as": "Name",
                                                maxlength: "14",
                                                required: "",
                                              },
                                              domProps: { value: _vm.cpfNO },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.cpfNO =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "cpfNO-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.cpfNO"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("cpfNO"),
                                                    expression:
                                                      "errors.has('cpfNO')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first("cpfNO")
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.errors.has("agency"),
                                          valid: _vm.isFormFieldValid("agency"),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.agency,
                                                  expression: "agency",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              attrs: {
                                                id: "agency-input",
                                                name: "agency",
                                                "data-vv-as": "Name",
                                                maxlength: "6",
                                                onkeyup:
                                                  "this.value=this.value.replace(/[^a-zA-Z0-9\\-]/g,'')",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                required: "",
                                              },
                                              domProps: { value: _vm.agency },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.agency =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "agency-input" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.agency"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.errors.has("agency"),
                                                    expression:
                                                      "errors.has('agency')",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first("agency")
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error": _vm.initSelectedVaild,
                                          valid: _vm.isBankVaild(_vm.selBank),
                                        },
                                        attrs: { id: "bankWrapper" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("vuestic-simple-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              ref: "bankInput",
                                              attrs: {
                                                label:
                                                  _vm.$t("forms.inputs.bank"),
                                                name: "selBank",
                                                "data-vv-as": "Name",
                                                autocomplete: "off",
                                                required: "",
                                                "option-key": "description",
                                                options: _vm.bankOptions,
                                              },
                                              on: { input: _vm.forbiddenInput },
                                              model: {
                                                value: _vm.selBank,
                                                callback: function ($$v) {
                                                  _vm.selBank = $$v
                                                },
                                                expression: "selBank",
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.initSelectedVaild,
                                                    expression:
                                                      "initSelectedVaild",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                                staticStyle: {
                                                  display: "block",
                                                  "margin-top": "-30px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "selBank"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                        class: {
                                          "has-error":
                                            _vm.initSelAccoutTypeVaild,
                                          valid: _vm.isAccountVaild(
                                            _vm.accountType
                                          ),
                                        },
                                        attrs: { id: "accountWrapper" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("vuestic-simple-select", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              ref: "accountInput",
                                              attrs: {
                                                label: _vm.$t(
                                                  "forms.inputs.accountType"
                                                ),
                                                name: "accountType",
                                                "data-vv-as": "Name",
                                                autocomplete: "off",
                                                required: "",
                                                "option-key": "description",
                                                options: _vm.accountOptions,
                                              },
                                              on: {
                                                input:
                                                  _vm.forbiddenAccountInput,
                                              },
                                              model: {
                                                value: _vm.accountType,
                                                callback: function ($$v) {
                                                  _vm.accountType = $$v
                                                },
                                                expression: "accountType",
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "small",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.initSelAccoutTypeVaild,
                                                    expression:
                                                      "initSelAccoutTypeVaild",
                                                  },
                                                ],
                                                staticClass: "help text-danger",
                                                staticStyle: {
                                                  display: "block",
                                                  "margin-top": "-30px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "accountType"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group with-icon-right",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.bankAccountNumberFirst,
                                                  expression:
                                                    "bankAccountNumberFirst",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "60%",
                                              },
                                              attrs: {
                                                id: "card_number",
                                                name: "card_number",
                                                "data-vv-as": "Name",
                                                onpaste: "return false",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                maxlength: "14",
                                                required: "",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.bankAccountNumberFirst,
                                              },
                                              on: {
                                                focus: function ($event) {
                                                  return _vm.formatCardNumber(
                                                    $event
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.bankAccountNumberFirst =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("—")]),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.bankAccountNumberLast,
                                                  expression:
                                                    "bankAccountNumberLast",
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'",
                                                },
                                              ],
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "20%",
                                                "padding-left": "10px",
                                              },
                                              attrs: {
                                                id: "branch_num",
                                                name: "branch_num",
                                                "data-vv-as": "Name",
                                                maxlength: "2",
                                                onkeyup:
                                                  "this.value=this.value.replace(/\\D/g,'')",
                                                onkeydown:
                                                  "this.value=this.value.replace(/\\D/g,'')",
                                                onpaste: "return false",
                                                ondragenter: "return false",
                                                ondragover: "return false",
                                                required: "",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.bankAccountNumberLast,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.bankAccountNumberLast =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                            }),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-check valid-icon icon-right input-icon",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "control-label",
                                                attrs: { for: "card_number" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "forms.inputs.bankAccountNumber"
                                                    )
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("i", { staticClass: "bar" }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group with-icon-right",
                                  class: {
                                    "has-error": _vm.errors.has("userPass"),
                                    valid: _vm.isFormFieldValid("userPass"),
                                  },
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userPass,
                                          expression: "userPass",
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'",
                                        },
                                      ],
                                      attrs: {
                                        id: "password",
                                        name: "userPass",
                                        "data-vv-as": "Password",
                                        type: "password",
                                        required: "",
                                        onkeyup:
                                          "value=value.replace(/\\s/g,'')",
                                        onkeydown:
                                          "value=value.replace(/\\s/g,'')",
                                      },
                                      domProps: { value: _vm.userPass },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.userPass = $event.target.value
                                        },
                                      },
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "password" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("auth.password")) +
                                            "：\n                      "
                                        ),
                                      ]
                                    ),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("userPass"),
                                            expression:
                                              "errors.has('userPass')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("userPass"))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "modals-page", attrs: { id: "fillOrder" } },
            [
              _c(
                "vuestic-modal",
                {
                  ref: "fillOrderModal",
                  staticClass: "fill-order-modal",
                  attrs: {
                    show: _vm.show,
                    okText: _vm._f("translate")("modal.confirm2"),
                    okClass: "btn btn-primary btn-micro",
                    cancelClass: "btn btn-secondary btn-micro",
                    cancelText: _vm._f("translate")("modal.cancel2"),
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.show = $event
                    },
                    cancel: _vm.fillOrderModalClose,
                  },
                },
                [
                  _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm._f("translate")("modal.fillOrder"))),
                  ]),
                  _c("div", [
                    _c("form", [
                      _c("div", { staticClass: "va-row" }, [
                        _c("div", { staticClass: "flex xs12 md12" }, [
                          _c("fieldset", [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("orderStatus"),
                                  valid: _vm.isFormFieldValid("orderStatus"),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'",
                                          },
                                        ],
                                        attrs: {
                                          id: "orderStatus",
                                          name: "orderStatus",
                                          "data-vv-as": "status",
                                          filterable: true,
                                          required: "",
                                          placeholder:
                                            _vm.$t("pleaseSelectStatus"),
                                        },
                                        on: { change: _vm.selectStatusCode },
                                        model: {
                                          value: _vm.fillStatus,
                                          callback: function ($$v) {
                                            _vm.fillStatus = $$v
                                          },
                                          expression: "fillStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.statusOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-check valid-icon icon-right input-icon",
                                    }),
                                    _c("i", { staticClass: "bar" }),
                                    _c(
                                      "small",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.errors.has("orderStatus"),
                                            expression:
                                              "errors.has('orderStatus')",
                                          },
                                        ],
                                        staticClass: "help text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.errors.first("orderStatus")
                                            ) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("userPass"),
                                  valid: _vm.isFormFieldValid("userPass"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userPass,
                                        expression: "userPass",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      name: "userPass",
                                      "data-vv-as": "Password",
                                      type: "password",
                                      id: "password",
                                      required: "required",
                                      onkeyup: "value=value.replace(/\\s/g,'')",
                                      onkeydown:
                                        "value=value.replace(/\\s/g,'')",
                                    },
                                    domProps: { value: _vm.userPass },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.userPass = $event.target.value
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "password" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$t("auth.password")) +
                                          "：\n                      "
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("userPass"),
                                          expression: "errors.has('userPass')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("userPass"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm.isToastContentPresent
            ? _c("div", { staticClass: "flex xs12 md6 flex-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "toasted-container sample-toasted-container shrink",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "toasted vuestic-toast none default",
                        staticStyle: { "justify-content": "flex-start" },
                      },
                      [
                        _vm.toastIcon
                          ? _c("i", { staticClass: "fa", class: _vm.toastIcon })
                          : _vm._e(),
                        _vm._v(
                          "\n          " + _vm._s(_vm.toastText) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c("create-order", {
        ref: "create-order-component",
        attrs: { appList: _vm.createOrderAppList },
        on: { newPayment: _vm.createNewPayment, close: _vm.searchOrder },
      }),
      _c("render-pdf-dom", {
        ref: "render-pdf-ref",
        attrs: { "refund-voucher": _vm.refundVoucher },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }